import React from "react"

export function DisclaimerIcon() {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
                <g id="2.signature-copy" transform="translate(-38.000000, -444.000000)">
                    <g id="noun_538056_cc" transform="translate(38.000000, 444.000000)">
                        <g id="Group">
                            <path
                                d="M12,0.182608696 C5.47826087,0.182608696 0.182608696,5.47826087 0.182608696,12 C0.182608696,18.5217391 5.47826087,23.8173913 12,23.8173913 C18.5217391,23.8173913 23.8173913,18.5217391 23.8173913,12 C23.8173913,5.47826087 18.5217391,0.182608696 12,0.182608696 L12,0.182608696 Z M12,19.5652174 C11.2173913,19.5652174 10.5913043,18.9391304 10.5913043,18.1565217 C10.5913043,17.373913 11.2173913,16.7478261 12,16.7478261 C12.7826087,16.7478261 13.4086957,17.373913 13.4086957,18.1565217 C13.4086957,18.9130435 12.7826087,19.5652174 12,19.5652174 L12,19.5652174 Z M12,15.3130435 C10.9565217,15.3130435 10.1217391,7.3826087 10.1217391,6.33913043 C10.1217391,5.29565217 10.9565217,4.43478261 12,4.43478261 C13.0434783,4.43478261 13.8782609,5.26956522 13.8782609,6.31304348 C13.8782609,7.35652174 13.0434783,15.3130435 12,15.3130435 L12,15.3130435 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
